module.exports = __webpack_public_path__ + "static/media/green_belt_icon.eeb9b212.svg";